<template>
    <div class="language-switcher" :id="id" v-if="supportedLocales.length > 1">
        <label>Language</label>

        <v-select v-model="locale" @change="changeLanguage" :attach="`#${id}`"
                  :items="supportedLocales" item-text="title" item-value="name" hide-details="true"
                  :menu-props="{contentClass: `language-switcher-list ${id}`, closeOnClick: true}">

            <template v-slot:selection="{ item }">
                <img :src="localeImage(item.icon)" :alt="item.title"/>
                <span v-text="short === true ? item.name : item.title"/>
            </template>

            <template v-slot:item="{ item }">
                <router-link :to="localeLink(item)"
                             event="" @click.native.prevent=""
                             v-if="mustLocaleHaveLink(item)">
                    <img :src="localeImage(item.icon)" :alt="item.title"/>
                    <span>{{ item.title }}</span>
                </router-link>
                <div v-else>
                    <img :src="localeImage(item.icon)" :alt="item.title"/>
                    <span>{{ item.title }}</span>
                </div>
            </template>
        </v-select>

        <div v-if="showBasicLinks" style="display: none">
            <a v-for="locale in supportedLocales" :href="localeLink(locale)" v-if="mustLocaleHaveLink(locale)">
                {{ locale.title }}
            </a>
        </div>
    </div>
</template>

<script>
import {changeLocale} from "../../../../../src/util/locale";
import {brandName} from "../../../../../config/app";
import {defaultLanguage, publicAppLocales} from '../../../../../config/localization';
import {mdiMenuDown} from '@mdi/js';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';

export default {
    name: "LanguageSwitcher",

    props: ['id', 'short'],

    components: {vueCustomScrollbar},

    data: function () {
        return {
            locale: this.$store.state.locale,
            supportedLocales: publicAppLocales,
            showBasicLinks: true,
            mdiMenuDown: mdiMenuDown,
            scrollbarSettings: {
                suppressScrollY: false,
                suppressScrollX: true,
                wheelPropagation: false,
            },
        };
    },

    mounted() {
        this.showBasicLinks = false;
    },

    computed: {
        page() {
            let pageData = this.$store.getters.getPageData(this.$route);

            return pageData && pageData.page;
        },
    },

    methods: {
        mustLocaleHaveLink(locale) {
            return this.page && (!Array.isArray(this.page.allowedLocales) || this.page.allowedLocales.includes(locale.name)) && locale.name.toLowerCase() !== this.$store.state.locale;
        },

        localeLink(locale) {
            let localeName = locale.name,
                routeLocale = localeName === defaultLanguage ? null : localeName.toLowerCase(),
                routeParams = {locale: routeLocale};

            routeParams.slug = null;

            if (this.page && this.page.slug && this.page.slug[localeName]) {
                routeParams.slug = this.page.slug[localeName];
            }

            let localeRoute = this.$router.resolve({
                params: routeParams,
                query: this.$route.query,
                hash: this.$route.hash,
            });

            return decodeURIComponent(localeRoute.resolved.fullPath);
        },

        localeImage(image) {
            return `/public/${brandName}/locale/${image}`;
        },

        changeLanguage(localeName) {
            changeLocale(this.$router, localeName, this.$cookies, this.$store);
        },
    },
}
</script>

<style lang="sass">
@import "sass/components/layout/LanguageSwitcher"
</style>